import React from 'react'
import { Sale } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { CustomPictureLabels } from 'src/components'
import { getFirstSubstring, getProjectKind, getSaleImage } from 'src/core/helpers'
const marketUrl = process.env.MARKET_PLACE_URL

const ProjectSaleColumn: React.FC<{ sale: Sale }> = ({ sale }) => {
  const { t } = useTranslation()
  const name = `${getFirstSubstring(sale.projectName, 16)}...`
  const projectName = sale.is_vintage ?  `${name} (${sale.vintageYear})` : name

  return (
    <CustomPictureLabels
      imageUrl={getSaleImage(sale)}
      title={projectName}
      subtitle={getProjectKind(sale.projectKind, t)}
      link={`${marketUrl}/projects?id=${sale.projectId}`}
    />
  )
}

export default ProjectSaleColumn
